import { DELETEADDATTACHMENT_SUCCESS, DELETEADDATTACHMENT_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const deleteAddAttachmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEADDATTACHMENT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEADDATTACHMENT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteAddAttachmentReducer;
